import { State } from '../reducers';
import ActionTypes from '../constants/ActionTypes';
import { Activity } from '../interfaces/Social';

export function getFeed(state: State, filters): Activity[] {
  const key = JSON.stringify(filters);
  if (state.feed.list[key]) {
    return state.feed.list[key].activities || [];
  }
  return [];
}

export function getFeedState(state: State, filters): string {
  const key = JSON.stringify(filters);
  if (state.feed.status[key]) {
    return state.feed.status[key];
  }
  return ActionTypes.FETCH_FEED_NOT_FOUND;
}
